module.exports = __webpack_public_path__ + "media/common/images/badges/gray/zrout_informaci-aecc19abf77b831cfd6e75516718cfb0.svg";